import { render, staticRenderFns } from "./ArticleImport.vue?vue&type=template&id=53f3d2c0&scoped=true"
import script from "./ArticleImport.vue?vue&type=script&lang=js"
export * from "./ArticleImport.vue?vue&type=script&lang=js"
import style0 from "./ArticleImport.vue?vue&type=style&index=0&id=53f3d2c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f3d2c0",
  null
  
)

export default component.exports